module.exports = __webpack_public_path__ + "static/media/rc10.4b76bb0b.jpg";